<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="路段名称">
              <a-input placeholder="请输入路段名称" v-model="queryParam.infoName" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="负责人">
              <a-input placeholder="请输入负责人" v-model="queryParam.chargePerson" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="所属区域">
              <a-input placeholder="请输入所属区域" v-model="queryParam.region" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => queryParam = {}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
    </s-table>
  </a-card>
</template>

<script>
import { TableMixin } from '@/mixins/TableMixin'
import { fetchList, delObj } from '@/api/project/ProjectCuringInfo'
import projectCuringInfoAddOrUpdate from './ProjectCuringInfoAddOrUpdate'
import Ellipsis from '@/components/Ellipsis'
import { enterEvent } from '@/utils/util'
export default {
  name: 'ProjectCuringInfoView',
  mixins: [TableMixin],
  components: {
    projectCuringInfoAddOrUpdate,
    Ellipsis
  },
  data () {
    return {
      description: '对公司的养护工程信息进行留档管理',
      queryParam: {
        infoName: '',
        region: '',
        chargePerson: ''
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '65px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '路段名称',
          width: '120px',
          dataIndex: 'infoName',
          customRender: (text) => {
            return (
              <div>
                <Ellipsis length={10} line={1} tooltip>{text}</Ellipsis>
              </div>
            )
          }
        },
        {
          title: '所属区域',
          width: '120px',
          dataIndex: 'region',
          customRender: (text) => {
            return (
              <div>
                <Ellipsis length={10} line={1} tooltip>{text}</Ellipsis>
              </div>
            )
          }
        },
        {
          title: '地址',
          width: '100px',
          dataIndex: 'address',
          customRender: (text) => {
            return (
              <div>
                <Ellipsis length={8} line={1} tooltip>{text}</Ellipsis>
              </div>
            )
          }
        },
        {
          title: '绿地面积',
          width: '90px',
          dataIndex: 'greenArea',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '道路长度',
          width: '90px',
          dataIndex: 'roadLength',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '道路宽度',
          width: '90px',
          dataIndex: 'roadWidth',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '负责人',
          width: '100px',
          dataIndex: 'chargePerson'
        },
        {
          title: '备注',
          width: '200px',
          dataIndex: 'remark',
          customRender: (text) => {
            return (
              // 文本省略，如果文本为空会报错。
              <div>
                {text === null ? ''
                  : <Ellipsis length={20} line={2} tooltip>{text}</Ellipsis>
                }

              </div>
            )
          }
        },
        {
          title: '操作',
          width: '170px',
          customRender: (record) => {
            return (
              <div>
                <span v-action="curing:projectCuringInfo:show">
                  <a onClick={(e) => this.show(record)}>查看</a>
                </span>
                <span v-action="curing:projectCuringInfo:edit">
                  <a-divider type="vertical" />
                  <a onClick={(e) => this.edit(record)}>修改</a>
                </span>
                <span v-action="curing:projectCuringInfo:del">
                  <a-divider type="vertical" />
                  <a-popconfirm title="是否删除" onConfirm={() => this.deleteItem(record)} okText="是" cancelText="否">
                    <a-icon slot="icon" type="question-circle-o" style="color: red" />
                    <a href="javascript:;" style="color: red">删除</a>
                  </a-popconfirm>
                </span>
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    show (record) {
      this.$router.push({ name: 'ProjectCuringInfoUpdate', query: { curingId: record.id, type: 'show' } })
    },
    edit (record) {
      this.$router.push({ name: 'ProjectCuringInfoUpdate', query: { curingId: record.id, type: 'edit' } })
    },
    deleteItem (record) {
      delObj(record.id).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    }
  },
  created () {
    enterEvent(this.queryPage)
  },
  activated () {
    this.queryPage()
  }
}
</script>

<style scoped>

</style>
